import type { PropsWithChildren } from 'react';

import { useInstantSearch } from 'react-instantsearch';

import logger from '../../utilities/logger';

export const AlgoliaErrorBoundary = ({ children }: PropsWithChildren) => {
  const { error } = useInstantSearch();

  if (error) {
    logger.error(error, `Algolia error: ${error.message}`);

    return <></>;
  }

  return <>{children}</>;
};
